module.exports = __webpack_public_path__ + "img/User_Square.ffae5569.svg";